import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminPageComponent } from '@app/admin/admin-page/admin-page.component';
import { AdminRoutingModule } from '@app/admin/admin-routing.module';
import { ButtonComponent, FormFieldModule, IconComponent, TileComponent } from '@totalenergiescode/tds-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ScenarioModule } from '@app/scenarios/scenario.module';

@NgModule({
    imports: [
        CommonModule,
        AdminRoutingModule,
        TileComponent,
        IconComponent,
        ButtonComponent,
        FormFieldModule,
        ReactiveFormsModule,
        ScenarioModule,
        AdminPageComponent,
    ],
})
export class AdminModule {}
